import { render, staticRenderFns } from "./UiZoomImage.vue?vue&type=template&id=3f2e4ece&scoped=true&"
import script from "./UiZoomImage.vue?vue&type=script&lang=js&"
export * from "./UiZoomImage.vue?vue&type=script&lang=js&"
import style0 from "./UiZoomImage.vue?vue&type=style&index=0&id=3f2e4ece&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2e4ece",
  null
  
)

export default component.exports